export default instance => link => {
  if (link.lag && instance.config.auto_scheduling) {
    return 'finish_to_start';
  }
};
